import { createFileRoute } from "@tanstack/react-router";
import GuidePage from "@/pages/GuidePage";

export const Route = createFileRoute("/guias/pequenas-bolinhas-no-penis")({
  component: GuidePage,
});